var _path, _path2, _g, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _g4, _path8, _g5, _path9, _g6, _path0, _path1, _g7, _path10, _path11, _g8, _path12, _path13, _path14, _path15, _g9, _path16, _g0, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPikkoLookingTheTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 200,
    viewBox: "0 0 175 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.531 62.3987C142.531 62.3987 96.7773 59.3179 96.4657 107.664C145.661 107.357 142.531 62.3987 142.531 62.3987Z",
    fill: "#71B261"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16353_40850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 58,
    width: 54,
    height: 53
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.358 58.5H92.7929V110.708H145.358V58.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16353_40850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.7882 110.291L96.4788 110.277C112.346 110.173 124.687 105.579 133.162 96.6014C146.431 82.5561 145.235 63.0392 145.178 62.2167L145.022 59.9513L142.707 59.791C142.707 59.791 142.055 59.7422 140.908 59.7422C133.092 59.7422 94.0998 62.0563 93.8024 107.642L93.7882 110.291Z",
    fill: "url(#paint0_linear_16353_40850)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_16353_40850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 11,
    width: 39,
    height: 73
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.303 11L69.2389 11V83.4846H107.303V11Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_16353_40850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.0497 82.5623L89.9402 80.6803C101.092 69.5835 106.508 57.7548 106.041 45.5219C105.312 26.3674 90.4287 13.4025 89.7915 12.8658L88.0497 11.3672L86.3008 12.8658C85.6636 13.4025 70.7805 26.3674 70.0512 45.5219C69.5839 57.7548 75.0005 69.5835 86.1521 80.6803L88.0497 82.5623Z",
    fill: "url(#paint1_linear_16353_40850)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2536 62.3987C32.2536 62.3987 78.0003 59.3179 78.3189 107.664C29.117 107.357 32.2536 62.3987 32.2536 62.3987Z",
    fill: "#71B261"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_16353_40850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 58,
    width: 53,
    height: 53
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9204 58.5H29.3554V110.708H81.9204V58.5Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_16353_40850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.9947 110.291L80.9734 107.642C80.676 62.0563 41.6842 59.7422 33.8745 59.7422C32.7203 59.7422 32.0689 59.791 32.0689 59.791L29.7607 59.9513L29.5979 62.2167C29.5412 63.0392 28.3446 82.5491 41.6133 96.6014C50.0815 105.579 62.4298 110.173 78.3041 110.277L80.9947 110.291Z",
    fill: "url(#paint2_linear_16353_40850)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_16353_40850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 88,
    width: 125,
    height: 140
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M149.002 88.1719H25.7465V227.816H149.002V88.1719Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_16353_40850)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_16353_40850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 88,
    width: 123,
    height: 140
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2634 227.826V88.2935C65.6811 88.2656 66.0918 88.2656 66.5095 88.2656H108.199V227.826H65.2634ZM118.883 227.826H108.199V88.2935H108.433C125.709 88.2935 140.875 102.171 142.121 119.116L147.963 197.038C149.244 213.948 136.153 227.826 118.883 227.826ZM56.0659 227.826C38.7897 227.826 25.7051 213.948 26.9795 197.003L32.828 119.088C34.0741 102.555 48.5536 88.9417 65.2917 88.2935V227.826H56.0659Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_16353_40850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8882 227.816H147.963V88.1719H26.8882V227.816Z",
    fill: "url(#paint3_linear_16353_40850)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_16353_40850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 67,
    y: 155,
    width: 40,
    height: 35
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.745 155.648H67.7032V189.746H106.745V155.648Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_16353_40850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.2276 198.677C88.5092 198.677 89.7766 198.54 91.0298 198.262C92.2901 197.99 93.5079 197.581 94.6904 197.042C95.8728 196.497 96.9986 195.838 98.0606 195.053C99.1298 194.269 100.114 193.375 101.02 192.378C101.927 191.375 102.734 190.291 103.442 189.114C104.157 187.943 104.759 186.7 105.247 185.393C105.736 184.09 106.104 182.745 106.359 181.361C106.607 179.971 106.727 178.576 106.727 177.16C106.727 175.749 106.607 174.348 106.359 172.964C106.104 171.58 105.736 170.235 105.247 168.927C104.759 167.625 104.157 166.382 103.442 165.211C102.734 164.034 101.927 162.95 101.02 161.947C100.114 160.95 99.1298 160.056 98.0606 159.272C96.9986 158.487 95.8728 157.828 94.6904 157.283C93.5079 156.744 92.2901 156.335 91.0298 156.063C89.7766 155.785 88.5092 155.648 87.2276 155.648C85.946 155.648 84.6786 155.785 83.4254 156.063C82.1651 156.335 80.9473 156.744 79.7648 157.283C78.5824 157.828 77.4566 158.487 76.3946 159.272C75.3254 160.056 74.3412 160.95 73.4349 161.947C72.5286 162.95 71.7215 164.034 71.0134 165.211C70.2983 166.382 69.6965 167.625 69.2079 168.927C68.7194 170.235 68.3512 171.58 68.0963 172.964C67.8485 174.348 67.7281 175.749 67.7281 177.16C67.7281 178.576 67.8485 179.971 68.0963 181.361C68.3512 182.745 68.7194 184.09 69.2079 185.393C69.6965 186.7 70.2983 187.943 71.0134 189.114C71.7215 190.291 72.5286 191.375 73.4349 192.378C74.3412 193.375 75.3254 194.269 76.3946 195.053C77.4566 195.838 78.5824 196.497 79.7648 197.042C80.9473 197.581 82.1651 197.99 83.4254 198.262C84.6786 198.54 85.946 198.677 87.2276 198.677Z",
    fill: "#3D1F1E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_16353_40850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 175,
    width: 35,
    height: 25
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.516 175.156H70.7567V199.044H104.516V175.156Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_16353_40850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.4911 187.097C70.4911 187.683 70.6044 188.264 70.8168 188.846C71.0363 189.422 71.3549 189.982 71.7797 190.527C72.2045 191.072 72.7214 191.585 73.3374 192.077C73.9534 192.564 74.6544 193.02 75.4403 193.434C76.2191 193.853 77.0759 194.225 77.9963 194.549C78.9168 194.879 79.8868 195.152 80.9134 195.377C81.9401 195.602 82.9951 195.775 84.0784 195.89C85.1688 196.005 86.2662 196.063 87.3708 196.063C88.4824 196.063 89.5799 196.005 90.6632 195.89C91.7536 195.775 92.8086 195.602 93.8352 195.377C94.8548 195.152 95.8319 194.879 96.7524 194.549C97.6728 194.225 98.5295 193.853 99.3084 193.434C100.094 193.02 100.795 192.564 101.411 192.077C102.027 191.585 102.544 191.072 102.969 190.527C103.394 189.982 103.712 189.422 103.932 188.846C104.144 188.264 104.251 187.683 104.251 187.097C104.251 186.505 104.144 185.923 103.932 185.342C103.712 184.766 103.394 184.206 102.969 183.661C102.544 183.116 102.027 182.603 101.411 182.111C100.795 181.624 100.094 181.168 99.3084 180.754C98.5295 180.335 97.6728 179.963 96.7524 179.639C95.8319 179.309 94.8548 179.036 93.8352 178.811C92.8086 178.586 91.7536 178.413 90.6632 178.298C89.5799 178.183 88.4824 178.125 87.3708 178.125C86.2662 178.125 85.1688 178.183 84.0784 178.298C82.9951 178.413 81.9401 178.586 80.9134 178.811C79.8868 179.036 78.9168 179.309 77.9963 179.639C77.0759 179.963 76.2191 180.335 75.4403 180.754C74.6544 181.168 73.9534 181.624 73.3374 182.111C72.7214 182.603 72.2045 183.116 71.7797 183.661C71.3549 184.206 71.0363 184.766 70.8168 185.342C70.6044 185.923 70.4911 186.505 70.4911 187.097Z",
    fill: "#FA5B5B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_16353_40850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 84,
    width: 56,
    height: 56
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3052 84.6953H24.1204V139.022H79.3052V84.6953Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_16353_40850)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_16353_40850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 84,
    width: 56,
    height: 56
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M51.705 84.6953C66.9491 84.6953 79.2974 96.8516 79.2974 111.859C79.2974 126.859 66.9491 139.022 51.705 139.022C36.4679 139.022 24.1126 126.859 24.1126 111.859C24.1126 96.8516 36.4679 84.6953 51.705 84.6953Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_16353_40850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.2974 84.6953H24.1126V139.022H79.2974V84.6953Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_16353_40850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 87,
    width: 35,
    height: 34
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4302 87.0312H34.0123V120.914H68.4302V87.0312Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_16353_40850)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_16353_40850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 87,
    width: 35,
    height: 34
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2255 87.0312C60.7345 87.0312 68.438 94.615 68.438 103.976C68.438 113.33 60.7345 120.914 51.2255 120.914C41.7236 120.914 34.0201 113.33 34.0201 103.976C34.0201 94.615 41.7236 87.0312 51.2255 87.0312Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_16353_40850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.438 87.0312H34.0201V120.914H68.438V87.0312Z",
    fill: "#3D1F1E"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9202 110.125C51.9202 106.047 48.8326 103.108 44.7813 103.108C48.6443 103.108 51.9169 99.9777 51.9169 96.0892C51.9169 99.9407 54.971 103.108 59.0591 103.108C54.971 103.108 51.9202 106.196 51.9202 110.125Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9202 96.0859L51.9169 96.0892M51.9169 96.0892C51.9169 99.9777 48.6443 103.108 44.7813 103.108C48.8326 103.108 51.9202 106.047 51.9202 110.125C51.9202 106.196 54.971 103.108 59.0591 103.108C54.971 103.108 51.9169 99.9407 51.9169 96.0892Z",
    stroke: "white",
    strokeWidth: 4.21504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_16353_40850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 85,
    width: 56,
    height: 55
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M148.583 85.6094H93.3977V139.936H148.583V85.6094Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_16353_40850)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_16353_40850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 85,
    width: 56,
    height: 55
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M120.982 85.6016C136.226 85.6016 148.575 97.7578 148.575 112.765C148.575 127.765 136.226 139.928 120.982 139.928C105.745 139.928 93.3899 127.765 93.3899 112.765C93.3899 97.7578 105.745 85.6016 120.982 85.6016Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_16353_40850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.575 85.6016H93.3899V139.928H148.575V85.6016Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_16353_40850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 103,
    y: 87,
    width: 36,
    height: 35
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M120.936 87.5C130.445 87.5 138.149 95.0837 138.149 104.445C138.149 113.799 130.445 121.383 120.936 121.383C111.435 121.383 103.731 113.799 103.731 104.445C103.731 95.0837 111.435 87.5 120.936 87.5Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_16353_40850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.149 87.5H103.731V121.383H138.149V87.5Z",
    fill: "#3D1F1E"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M121.637 110.609C121.637 106.532 118.549 103.593 114.498 103.593C118.361 103.593 121.634 100.462 121.634 96.5735C121.634 100.425 124.688 103.593 128.776 103.593C124.688 103.593 121.637 106.68 121.637 110.609Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M121.637 96.5703L121.634 96.5735M121.634 96.5735C121.634 100.462 118.361 103.593 114.498 103.593C118.549 103.593 121.637 106.532 121.637 110.609C121.637 106.68 124.688 103.593 128.776 103.593C124.688 103.593 121.634 100.425 121.634 96.5735Z",
    stroke: "white",
    strokeWidth: 4.21504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16353_40850",
    x1: 119.509,
    y1: 59.7422,
    x2: 119.509,
    y2: 110.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16353_40850",
    x1: 88.0461,
    y1: 11.3672,
    x2: 88.0461,
    y2: 82.5623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16353_40850",
    x1: 55.2707,
    y1: 59.7422,
    x2: 55.2707,
    y2: 110.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16353_40850",
    x1: 87.4258,
    y1: 88.1719,
    x2: 87.4258,
    y2: 227.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#FFDE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F19F10"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPikkoLookingTheTop);
export default __webpack_public_path__ + "static/media/pikkoLookingTheTop.30622dc8a1de798b0b27849059d55253.svg";
export { ForwardRef as ReactComponent };